import { Injectable } from '@angular/core';

@Injectable()
export class BlockingSpinnerService {
  private element: any;
  private backsafeTimeoutInstance: any;
  private backsafeTimeout = 300000;

  init(element: any) {
    this.element = element;
  }

  destroy() {
    this.element = undefined;
  }

  show() {
    if (this.element) {
      this.initBacksafeTimeout();
      this.element.open();
    }
  }

  close() {
    if (this.element) {
      this.clearTimeout();
      this.element.close();
    }
  }

  clearTimeout() {
    if (this.backsafeTimeoutInstance !== null) {
      clearTimeout(this.backsafeTimeoutInstance);
    }
  }

  initBacksafeTimeout() {
    const that = this;
    this.clearTimeout();
    this.backsafeTimeoutInstance = setTimeout(() => {
      that.close();
    }, this.backsafeTimeout);
  }

}
